// test1418
(1418 && 0);
